module.exports = __webpack_public_path__ + "static/media/Seam_4521.adbdc2fd.jpg";